<template>
  <div style="display: inline-block">
    <!-- <v-btn
      color="grey lighten"
      outline
      v-if="selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'"
    >
      <i class="fas fa-exchange-alt mr-1"></i>
      {{ $t('Transfer') }}
      <v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
    </v-btn> -->
    <v-btn color="primary" @click="openModal" outline>
      <i class="fas fa-exchange-alt mr-1"></i>
      {{ $t('Transfer') }}
    </v-btn>
    <v-dialog v-model="showTransfer" scrollable max-width="1000px">
      <v-card>
        <v-premium-plan-popup
          text="Don't waste time setting up conversations on a new page. Just select the page and press transfer. It can be used at all. Starting at 500 baht/month. Upgrade now!"
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium'"
        ></v-premium-plan-popup>
        <v-card-title>
          <v-layout wrap row class="mb-0">
            <v-flex xs12 sm5 class="text-xs-center">
              <v-menu offset-y offset-overflow max-height="200" :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn outline round color="primary" v-on="on">
                    <template v-if="currentPage">
                      <div
                        class="text-truncate"
                        style="display:inline-block; word-break: break-all;max-width: 150px;    vertical-align: middle;"
                      >
                        {{ currentPage.name }}
                      </div>
                    </template>
                    <template v-else>{{ $t('Select page') }}</template>
                  </v-btn>
                </template>
                <v-card>
                  <div class="form-control pa-1">
                    <input
                      type="text"
                      v-model="searchOptionBotlist"
                      class="mb-0"
                      :placeholder="$t('Search')"
                    />
                  </div>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in optionBotlist"
                      :key="index"
                      @click="selectBot(item)"
                    >
                      <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm2 class="text-xs-center">
              <i class="fas fa-arrow-right hidden-xs-only mt-3"></i>
              <i class="fas fa-arrow-down hidden-sm-and-up mt-2"></i>
            </v-flex>

            <v-flex xs12 sm5 class="text-xs-center pt-3">
              <template
                v-if="
                  $aston.astonpages.includes(selectedBot.pageid) &&
                    $store.getters.getPackage == 'premium'
                "
              >
                <v-select
                  v-model="selectedBotlist"
                  :items="premiumBot"
                  single-line
                  multiple
                  outline
                  item-text="pagename"
                  item-value="pageid"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.pagename | truncate(20) }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ selectedBotlist.length - 1 }} others)</span
                    >
                  </template>
                </v-select>
              </template>
              <template v-else>
                {{ selectedBot.pagename }}
              </template>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;" class="pa-0">
          <div v-if="loading" class="spinner text-xs-center mt-2 mb-2">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <div class="text-xs-center mt-4 mb-4" v-else-if="comparelist.length == 0">
            {{ $t('Choose page to transfer') }}
          </div>
          <div class="pb-2" v-else>
            <v-layout style="background: #eee;">
              <v-flex>
                <v-list-tile>
                  <v-list-tile-action @click.prevent="toggleSelect(selectAll)">
                    <v-checkbox v-model="selectAll" color="primary"></v-checkbox>
                  </v-list-tile-action>

                  <v-list-tile-content
                    @click.prevent="
                      selectAll = !selectAll
                      toggleSelect(selectAll)
                    "
                  >
                    <v-list-tile-title>
                      {{ $t('Select All') }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-flex>
              <v-flex>
                <div class="form-control pa-1">
                  <input type="text" v-model="search" class="mb-0" :placeholder="$t('Search')" />
                </div>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>

            <template v-for="(compare, index) in filterComparelist">
              <v-list-tile :key="'compare_' + compare.id">
                <v-list-tile-action>
                  <v-checkbox v-model="compare.selected" color="primary"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="compare.selected = !compare.selected">
                  <v-list-tile-title>
                    <template v-if="compare.intentname == '{default}'">
                      {{ $t('Default Conversation') }}
                    </template>
                    <template v-else-if="compare.intentname == '{default_comment_to_inbox}'">
                      {{ $t('More Comment to Inbox') }}
                    </template>
                    <template v-else-if="compare.intentname == '{welcome}'">
                      {{ $t('Welcome Message') }}
                    </template>
                    <template v-else>{{ compare.intentname }}</template>
                  </v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action
                  class="text-xs-center"
                  @click.prevent="compare.selected = !compare.selected"
                >
                  <v-list-tile-action-text v-if="!compare.page2" style="margin: auto;">
                    {{ $t('Insert2') }}
                  </v-list-tile-action-text>
                  <v-list-tile-action-text v-else style="margin: auto;" class="info--text">
                    {{ $t('Replace') }}
                  </v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < filterComparelist.length"
                :key="index"
                class="mt-2"
              ></v-divider>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout wrap>
            <v-flex
              xs12
              sm8
              class="px-2 py-2"
              :class="{
                'red--text':
                  (totalIntent > maxintent &&
                    selectedBot.pagetype != 'enterprise' &&
                    $store.getters.getPackage != 'premium') ||
                  (totalIntent > max_custom_intent && selectedBot.pagetype != 'enterprise')
              }"
            >
              {{ $t('Current items') }} {{ currentIntent }} <span shrink class="px-2">+</span>
              {{ $t('New items') }} {{ newIntent }} <span shrink class="px-2">=</span>
              {{ totalIntent }}
            </v-flex>
            <v-flex xs12 sm4>
              <div class="text-xs-left text-sm-right py-2 pr-3 pl-2">
                <template
                  v-if="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                  >{{ $t('Maximum') }} {{ maxintent }}</template
                >
                <template v-else-if="selectedBot.pagetype != 'enterprise'"
                  >{{ $t('Maximum') }} {{ max_custom_intent }}</template
                >
                <template v-else>{{ $t('Unlimit') }}</template>
              </div>
            </v-flex>
          </v-layout>

          <div class="text-xs-right">
            <v-btn outline color="grey" @click="showTransfer = false">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" :loading="loading" :disabled="isSelected == 0" @click="saveTransfer">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import api from '@/api'
import dayjs from 'dayjs'
export default {
  props: ['type', 'intents', 'total_count', 'all_count'],
  data: () => {
    return {
      showTransfer: false,
      test: false,
      currentPage: null,
      comparelist: [],
      loading: true,
      selectAll: false,
      search: '',
      searchOptionBotlist: '',
      maxintent: 10,
      selectedBotlist: [],
      max_custom_intent: 99
    }
  },
  components: {
    ModalDialog
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    premiumBot() {
      return this.botlist.filter(el => {
        let now = dayjs()
        let date = dayjs(el.expireat)
        let expriedTime = parseInt(date.diff(now, 'seconds'))

        return expriedTime > 0
      })
    },
    optionBotlist: function() {
      let options = []
      let vm = this
      try {
        if (vm.botlist) {
          options = vm.botlist
            .filter(val => {
              return val.pageid != vm.selectedBot.pageid
            })
            .map(val => {
              return { name: val.pagename, value: val.pageid }
            })
        }
      } catch (error) {
        console.log(error)
      }

      if (!this.searchOptionBotlist || this.searchOptionBotlist == '') {
        return options
      }

      return options.filter(el => {
        return el.name.toLowerCase().includes(this.searchOptionBotlist.toLowerCase())
      })
    },
    isSelected: function() {
      return this.comparelist.filter(function(el) {
        return el.selected
      }).length
    },
    filterComparelist() {
      if (!this.search || this.search == '') {
        return this.comparelist
      }

      return this.comparelist.filter(el => {
        return el.intentname.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    totalIntent() {
      return this.currentIntent + this.newIntent
    },
    currentIntent() {
      const vm = this
      if (!vm.intents) return 0
      return vm.all_count
    },
    newIntent() {
      var insertlist = this.comparelist.filter(el => {
        return el.selected && el.page2 == false
      })
      return insertlist.length
    }
  },
  async mounted() {
    const vm = this
    let package_config = vm.getPackageConfig()

    if (vm.selectedBot.pageid == '176922345693076' || vm.selectedBot.pageid == '1667559336833768') {
      vm.max_custom_intent = 500
    }

    if (
      vm.$aston.astonpages.includes(vm.selectedBot.pageid) &&
      vm.$store.getters.getPackage == 'premium'
    ) {
      vm.max_custom_intent = 999
    }

    vm.maxintent =
      vm.type == 'conversation' ? package_config.inbox : package_config.reply_comment

    // ถ้า custom แล้วอันใดอันนึงไม่เท่ากัน
    if (vm.maxintent > vm.max_custom_intent) vm.max_custom_intent = vm.maxintent
    else if (vm.maxintent < vm.max_custom_intent) vm.maxintent = vm.max_custom_intent

  },
  methods: {
    getIntent: function() {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            resolve(response.data)
          } else reject()
        })
      })
    },
    openModal: function() {
      var vm = this
      vm.showTransfer = true
      if (vm.currentPage) {
        vm.loading = true
        vm.getCompareIntents(vm.currentPage).then(
          function() {
            vm.loading = false
          },
          function() {
            vm.loading = false
          }
        )
      } else {
        vm.loading = false
      }
    },
    selectBot(page) {
      var vm = this
      vm.currentPage = page
      vm.loading = true
      vm.getCompareIntents(vm.currentPage).then(
        function() {
          vm.loading = false
        },
        function() {
          vm.loading = false
        }
      )
    },
    getCompareIntents: function(page) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid1: page.value,
          pageid2: vm.selectedBot.pageid,
          type: vm.type == 'replycomment' ? 'replycomment' : 'conversation'
        }
        api.getCompareIntents(data, function(error, response) {
          if (error) {
            reject(error)
          }
          vm.comparelist = []
          if (response.data) {
            response.data = response.data.sort(function(a, b) {
              var nameA = a.intentname.toLowerCase()
              var nameB = b.intentname.toLowerCase()
              if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
                return 1
              }
              if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
                return -1
              }
              if (nameA < nameB) {
                return -1
              }
              if (nameA > nameB) {
                return 1
              }
            })
            response.data.map(function(el) {
              let compare = el
              compare.selected = true
              vm.comparelist.push(compare)
            })
          }
          resolve()
        })
      })
    },
    saveTransfer: function() {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Are you sure you want to transfer the conversation?'),
          text: vm.$t(
            'Once you confirmed, you cannot go back and the existing conversation will be replaced.'
          ),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            var intentsid = []

            if (vm.comparelist) {
              intentsid = vm.comparelist
                .filter(el => {
                  return el.selected
                })
                .map(function(el) {
                  return el.id
                })
            }

            if (
              vm.totalIntent > vm.maxintent &&
              vm.selectedBot.pagetype != 'enterprise' &&
              vm.$store.getters.getPackage != 'premium'
            ) {
              vm.$swal.fire({
                type: 'error',
                title: vm.$t(
                  'Transferring conversation cannot be applied since you have reached {size} set of Q&A.',
                  { size: vm.maxintent }
                ),
                footer: `<div class="text-xs-center"><a href="/${vm.$i18n.locale()}/upgrade">${vm.$t(
                  'If you wish to transfer, please click here to upgrade to premium package'
                )}</a></div>`
              })
              return false
            }

            if (
              vm.totalIntent > vm.max_custom_intent &&
              vm.selectedBot.pagetype != 'enterprise' &&
              !vm.$store.state.UnlimitedConversation.includes(vm.selectedBot.pageid)
            ) {
              vm.$swal.fire({
                type: 'error',
                title: vm.$t(
                  'Transferring conversation cannot be applied since you have reached {size} set of Q&A.',
                  { size: vm.max_custom_intent }
                )
              })
              return false
            }

            if (intentsid.length == 0) {
              return false
            }

            var data = {
              pageid1: vm.currentPage.value,
              pageid2: vm.selectedBot.pageid,
              intentsid: intentsid.join(',')
            }

            if (
              vm.$aston.astonpages.includes(vm.selectedBot.pageid) &&
              vm.$store.getters.getPackage == 'premium'
            ) {
              data.pageid2 = vm.selectedBotlist.join(',')
            } else {
              data.pageid2 = vm.selectedBot.pageid
            }

            vm.$store.dispatch('loading')
            api.transferIntents(data, function(error, response) {
              if (error) {
                vm.$store.dispatch('loading')
                vm.$swal.fire({
                  title: vm.$t('Transfer conversation unsuccessful'),
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
                return false
              }
              vm.showTransfer = false
              vm.$store.dispatch('loading')
              vm.$swal
                .fire({
                  title: vm.$t('Transfer conversation successful'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
                .then(function(result) {
                  if (result.value) {
                    location.reload()
                  }
                })
            })
          }
        })
    },
    toggleSelect: function(value) {
      var vm = this
      if (vm.comparelist) {
        vm.comparelist.map(function(compare, index) {
          vm.comparelist[index].selected = value
        })
      }
    }
  },
  watch: {
    isSelected: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectAll = newVal == this.comparelist.length
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/TransferIntent.vue